import { Label } from '@cian/ui-kit';
import * as React from 'react';

import styles from './CommercialLabelsContainer.css';
import { AuctionBadge } from '../../../../components/Commercial/AuctionBadge';
import { OnlyCianBadge } from '../../../../components/Commercial/OnlyCianBadge';
import { OwnerBadge } from '../../../../components/Commercial/OwnerBadge';
import { GeneralInfoSectionRow } from '../../../../components/GeneralInfoSectionRow';
import { mapLabelBgColor, mapLabelColor } from '../../../../components/LabelsList/mapColors';
import { mapLabelIcon, mapLabelRightIcon } from '../../../../components/LabelsList/mapIcons';
import { mapLabelTextToTestId } from '../../../../components/LabelsList/mapTestId';
import { useOfferContext } from '../../../../context';
import { isElectronicTradingAuction } from '../../../../utils/computedProps/commercial/isElectronicTradingAuction';

const COMMERCIAL_BADGE_TEXTS = new Set(['Аукцион', 'Только на Циан', 'Собственник']);

export function CommercialLabelsContainer() {
  const { offer, labels } = useOfferContext();

  const hasOnlyCianLabel = labels.some(({ text }) => text === 'Только на Циан');
  const hasOwnerLabel = labels.some(({ text }) => text === 'Собственник');

  const showAuction = isElectronicTradingAuction(offer);
  const showOnlyCian = Boolean(offer.isUniqueForCian) || hasOnlyCianLabel;
  const showOwner =
    Boolean(offer.isByHomeowner || offer.isByCommercialOwner || offer.commercialOwnership?.isFromOwner) ||
    hasOwnerLabel;

  const filteredLabels = labels.filter(({ text }) => !COMMERCIAL_BADGE_TEXTS.has(text));

  const hasBadges = showAuction || showOnlyCian || showOwner;
  const hasLabels = filteredLabels.length > 0;

  if (!hasBadges && !hasLabels) {
    return null;
  }

  return (
    <GeneralInfoSectionRow>
      <div className={styles['row']} data-name="CommercialLabelsList" onClick={e => e.stopPropagation()}>
        {showAuction && (
          <div className={styles['item']}>
            <AuctionBadge />
          </div>
        )}
        {showOnlyCian && (
          <div className={styles['item']}>
            <OnlyCianBadge />
          </div>
        )}
        {showOwner && (
          <div className={styles['item']}>
            <OwnerBadge />
          </div>
        )}
        {filteredLabels.map((label, idx) => (
          <div className={styles['item']} key={`label-${idx}`}>
            <Label
              background={mapLabelBgColor(label.color, false)}
              color={mapLabelColor(label.color, false)}
              icon={mapLabelIcon(label.color, false)}
              rightIcon={mapLabelRightIcon(label.color)}
              tabIndex={label.onClick ? 0 : undefined}
              onClick={label.onClick}
              data-testid={mapLabelTextToTestId(label.text)}
            >
              {label.text}
            </Label>
          </div>
        ))}
      </div>
    </GeneralInfoSectionRow>
  );
}

CommercialLabelsContainer.displayName = 'CommercialLabelsContainer';
